import { LoadingScreen } from "../common/LoadingScreen";
import { useBrandIdentity } from "../../hooks/useBrandIdentity";

/**
 * Brand-portal splash: titles the loading screen with the tenant's name once
 * known — including before BrandProvider mounts, via the module-level cache.
 * Falls back to "Reveshare" when no tenant identity is available yet.
 */
export function BrandLoadingScreen() {
  const { name } = useBrandIdentity();
  return <LoadingScreen title={name ?? "Reveshare"} />;
}
